import type { Requirement } from './types';

/** A selectable color theme, unlocked by progress. Applied via a .theme-<id> class. */
export interface ThemeDef {
  id: string;
  name: string;
  icon: string;
  /** Unlock condition (empty = always available). */
  requires?: Requirement;
}

export const THEMES: readonly ThemeDef[] = [
  { id: 'default', name: 'Bergwerk', icon: '⛏️' },
  { id: 'emerald', name: 'Smaragd', icon: '💚', requires: { depth: 6 } },
  { id: 'gilded', name: 'Vergoldet', icon: '🟡', requires: { lifetimeEarnings: 1e9 } },
  { id: 'magma', name: 'Magma', icon: '🌋', requires: { resets: 1 } },
  { id: 'void', name: 'Leere', icon: '🌌', requires: { resets: 5 } },
] as const;

export const THEME_BY_ID: Record<string, ThemeDef> = Object.fromEntries(
  THEMES.map((t) => [t.id, t]),
);
